export enum UserType {
  SUPERADMIN = "SUPERADMIN",
  ADMIN = "ADMIN",
  LEADER = "LEADER",
  USER = "USER"
}